import { StyleSheet } from "react-native";

/** Dev-only marking colour: magenta, outside the board's role palette. */
export const DEV_COLOR = "#FF2EE6";

export const devStyles = StyleSheet.create({
  box: {
    position: "absolute",
    zIndex: 1000,
    top: 6,
    left: 6,
    backgroundColor: "rgba(18,18,18,0.92)",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#3A3F45",
  },
  pill: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderColor: DEV_COLOR,
    borderStyle: "dashed",
  },
  panel: { width: 290, maxHeight: "92%", padding: 6 },
  scroll: { flexGrow: 0 },
  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    marginVertical: 1,
  },
  wrap: { flexWrap: "wrap", marginTop: 4 },
  text: { color: "#D0D4D9", fontSize: 11 },
  dim: { color: "#8A9099", fontSize: 10 },
  title: { fontWeight: "600" },
  devTitle: { color: DEV_COLOR, fontWeight: "700" },
  label: { width: 92 },
  value: { width: 38, textAlign: "right" },
  btn: {
    borderWidth: 1,
    borderColor: "#3A3F45",
    borderRadius: 4,
    paddingHorizontal: 5,
    paddingVertical: 2,
  },
  on: { backgroundColor: "#3A3F45", borderColor: "#8A9099" },
  disabled: { opacity: 0.4 },
  input: {
    borderWidth: 1,
    borderColor: "#3A3F45",
    borderRadius: 4,
    color: "#EAEAEA",
    fontSize: 11,
    paddingHorizontal: 4,
    paddingVertical: 2,
    minWidth: 0,
    flex: 1,
  },
  section: { marginTop: 4 },
  error: { color: "#F76980", fontSize: 10, marginTop: 2 },
  copied: { marginTop: 4, fontSize: 10, color: "#D0D4D9", maxHeight: 120 },
  tab: { paddingHorizontal: 5, paddingVertical: 2, borderRadius: 4 },
});
